import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    width: 38rem;
    position: relative;
    margin: 0 0.5rem;
  }

  .container :global(a) {
    text-decoration: none;
    transition: opacity 100ms ease;
    padding-top: 2.5rem;
    display: flex;
    flex-direction: column;
  }

  .container :global(a:active) {
    opacity: 0.6;
  }

  .container :global(img) {
    pointer-events: none;
  }

  .container :global(.info) {
    margin: 2rem 0;
  }

  .container :global(.title) {
    ${common.title};

    font-family: 'Taviraj-Light', serif;
    color: ${colors.almostBlack};
    margin-bottom: 1rem;
    text-align: center;
  }

  .container :global(.sub-title) {
    ${common.text};

    font-family: 'Open Sans Regular', sans-serif;
    color: ${colors.bluishGrey};
    text-align: center;
  }

  .container :global(.computer) {
    position: relative;
  }

  .container :global(.color-case) {
    position: absolute;
    bottom: 0;
    width: 38rem;
  }

  .container :global(.color-case img) {
    width: 100%;
  }

  .container :global(.mac) {
    position: relative;
    width: 37.9rem;
    height: 22rem;
    transition: transform 200ms ease-in-out;
  }

  .container :global(.photo) {
    position: absolute;
    left: 6rem;
    top: 0.8rem;
    width: 25.5rem;
    height: 17rem;
  }

  .container :global(.photo img) {
    width: 100%;
    height: 100%;
  }

  .container :global(.frame) {
    position: absolute;
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .container {
      width: auto;
      margin-left: -6rem;
      margin-right: -6rem;
    }

    .container :global(.mac) {
      transform: scale(0.85);
    }

    .container :global(.color-case) {
      position: absolute;
      left: -50%;
      width: 200% !important;
      overflow: visible !important;
    }
  }

  @media screen and (min-width: ${sizes.media.tablet.maxWidth}) {
    .container :global(a:hover .mac),
    .container :global(a[keyboard-focus] .mac) {
      transform: translateY(-2rem);
    }
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      overflow: visible !important;
    }

    .container :global(a) {
      flex-direction: column-reverse;
    }

    .container :global(.color-case img) {
      width: 100%;
      height: 100%;
    }
  }
`
